module.exports = __webpack_public_path__ + "img/Real State_Recall_3_Set.cdc58048.png";